'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/vuetable-2/~/axios/lib/cancel/isCancel.js
// module id = 136
// module chunks = 0